import {
	CDDRecord,
	isAssociationCDDRecord,
	isCompanyCDDRecord,
	isIndividualCDDRecord,
	isRegisteredBodyCDDRecord,
	isTrustCDDRecord,
} from '../../types/cdd-records.types';

// ─── Helpers ────────────────────────────────────────────────────────────────

export function getEntityName(record: CDDRecord): string {
	if (isCompanyCDDRecord(record)) return record.profile.legalName;
	if (isTrustCDDRecord(record)) return record.profile.trustName;
	if (isAssociationCDDRecord(record)) return record.profile.name;
	if (isRegisteredBodyCDDRecord(record)) return record.profile.name;
	if (isIndividualCDDRecord(record)) return `${record.profile.firstName} ${record.profile.lastName}`;
	return (record as CDDRecord).referenceNumber;
}

export function getEntityRef(record: CDDRecord): string {
	if (isCompanyCDDRecord(record)) return record.profile.registration.acn || record.profile.registration.abn || '';
	if (isTrustCDDRecord(record)) return record.profile.registration.abn || '';
	return '';
}

export function fmtDate(d?: string): string {
	if (!d) return '—';
	return new Date(d).toLocaleDateString('en-AU', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function capitalize(s: string): string {
	return s.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

// ─── Layout constants (mm) ──────────────────────────────────────────────────

export const ML = 20;         // left margin
export const MR = 20;         // right margin
export const MT = 28;         // top margin (below header)
export const MB = 22;         // bottom margin (above footer)
export const LINE_H = 5.5;    // line height for body text
export const SECTION_GAP = 8; // gap before a new section heading

// ─── Colors ─────────────────────────────────────────────────────────────────

export const C = {
	black: [30, 30, 30] as [number, number, number],
	dark: [55, 65, 81] as [number, number, number],
	mid: [107, 114, 128] as [number, number, number],
	light: [156, 163, 175] as [number, number, number],
	line: [229, 231, 235] as [number, number, number],
	accent: [79, 70, 229] as [number, number, number],   // indigo-600
	green: [5, 150, 105] as [number, number, number],
	amber: [217, 119, 6] as [number, number, number],
	red: [225, 29, 72] as [number, number, number],
	white: [255, 255, 255] as [number, number, number],
	bgLight: [249, 250, 251] as [number, number, number],
};

// ─── Risk color helper ──────────────────────────────────────────────────────

export function riskColor(level: string): [number, number, number] {
	switch (level.toLowerCase()) {
		case 'low': return C.green;
		case 'medium': return C.amber;
		case 'high': case 'critical': return C.red;
		default: return C.dark;
	}
}
